'use client';

import { FC } from 'react';
import {
  replaceTokensInString,
  replaceTokensInUrl
} from '@cat-ecom/common/utils/stringUtils';
import { HEADLESS_SSO_PAGE, SSRO_BUNDLE_PAGE } from 'constants/links';
import { JobRecommendationDetail } from 'services/product/types';
import { getSeoUrl, normalizeCommerceLink } from 'utils/links';
import { useParams } from 'next/navigation';
import { LOCATION_HASH_KEY } from 'components/my-equipment/constants';
import RepairListItem from './repair-list-item';

export interface RepairListProps {
  jobIdsWithJobNameData: JobRecommendationDetail[];
  storeId: string;
  langId: string;
  catalogId: string;
  salesModel: string;
  serialNumber: string;
  unit: string;
  isHeadlessSSOEnabled: boolean;
  isMobileButtonView?: boolean;
  isPCCFrequentlyBoughtTogether?: boolean;
  partName: string;
  partNumber: string;
}

const RepairList: FC<RepairListProps> = ({
  jobIdsWithJobNameData,
  storeId,
  langId,
  catalogId,
  salesModel,
  serialNumber,
  unit,
  isHeadlessSSOEnabled,
  isMobileButtonView = false,
  isPCCFrequentlyBoughtTogether = false,
  partName,
  partNumber
}) => {
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const params = useParams();
  const esiteUrl = getSeoUrl(params);
  const onHandleClick = (ssId, isPM) => {
    const legacySSOURL = normalizeCommerceLink(
      replaceTokensInUrl(
        SSRO_BUNDLE_PAGE,
        storeId,
        catalogId,
        langId,
        ssId,
        isPM,
        serialNumber,
        salesModel,
        unit
      )
    );
    const updatedPartName = partName?.toLowerCase()?.replace(/\s+/g, '-');
  const headlessSSOURL = `${esiteUrl}${replaceTokensInString(
      HEADLESS_SSO_PAGE,
      updatedPartName,
      partNumber,
      ssId
    )}`;
    const url = isHeadlessSSOEnabled
      ? headlessSSOURL
      : `${legacySSOURL}${LOCATION_HASH_KEY.MAINTENANCE_REPAIRS}`;
    window.location.href = url;
  };

  return jobIdsWithJobNameData?.map((item) => {
    return (
      <>
        {isMobileButtonView ? (
          <>
            <div className="d-md-none">
              <RepairListItem
                item={item}
                onHandleClick={onHandleClick}
                key={item.jobId + '-mobile'}
                isButtonView
                isPCCFrequentlyBoughtTogether={isPCCFrequentlyBoughtTogether}
              />
            </div>
            <div className="d-none d-md-block">
              <RepairListItem
                item={item}
                onHandleClick={onHandleClick}
                key={item.jobId}
              />
            </div>
          </>
        ) : (
          <RepairListItem
            item={item}
            onHandleClick={onHandleClick}
            key={item.jobId}
          />
        )}
      </>
    );
  });
};
export default RepairList;
